import { render, staticRenderFns } from "./projectuserlist.vue?vue&type=template&id=3dbfa313"
import script from "./projectuserlist.vue?vue&type=script&lang=js"
export * from "./projectuserlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports